import camelCase from 'lodash/camelCase';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { projectSettingsServicedeskSurveysRoute } from '@atlassian/jira-router-routes-project-settings-service-desk-surveys-routes/src/projectSettingsServicedeskSurveysRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { surveysPageEntryPoint } from './ui/index.tsx';

export const projectSettingsServicedeskSurveysRouteEntry = createEntry(
	projectSettingsServicedeskSurveysRoute,
	() => ({
		group: 'project-settings-servicedesk',

		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarServicedesk,
			sidebarId: SIDEBAR_ID.PROJECT_SETTINGS,
		},

		meta: {
			reporting: {
				id: 'jsm.surveys-list',
				packageName: camelCase('surveys-list'),
				teamName: 'JSM Phoenix',
			},
		},

		layout: serviceProjectLayout,
		resources: [...getServiceDeskSettingsResources()],
		perfMetricKey: 'jsm-surveys',
		entryPoint: () =>
			fg('phx-2293_add_surveys_routes_under_project_settings') ? surveysPageEntryPoint : undefined,

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-project-settings-service-desk-surveys-entries/src/projectSettingsServicedeskSurveysRouteEntry.tsx',
				whichExportToUse: 'projectSettingsServicedeskSurveysRouteEntry',
			},

			enabled: true,
		},
	}),
);
